import { email } from "node_modules/zod/dist/types/v4/core/regexes";
import { z } from "zod";

export enum UserType {
  COACH = "COACH",
  PLAYER = "PLAYER",
}

export const createUserSchema = z.object({
  first_name: z
    .string({
      required_error: "First Name is required",
      message: "First Name must be a string",
    })
    .min(1, { message: "First Name must be at least 1 characters long" }),
  last_name: z
    .string({
      required_error: "Last Name is required",
      message: "Last Name must be a string",
    })
    .min(1, { message: "Last Name must be at least 1 characters long" }),
  email: z
    .string({ required_error: "Email is required" })
    .email({ message: "Email must be a valid email" }),
  type: z.nativeEnum(UserType, {
    message: `Type must be one of ${Object.values(UserType).join(", ")}`,
  }),
  password: z
    .string({ required_error: "Password is required" })
    .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/, {
      message:
        "Password must contain at least 8 character long, one uppercase letter, one lowercase letter, and one number",
    }),
});

export type CreateUserModel = z.infer<typeof createUserSchema>;

export const userSchema = createUserSchema.extend({
  id: z.string({ required_error: "Id is required" }),
  email_verified: z.boolean().default(false),
  remember_me: z.boolean().default(false),
  is_active: z.boolean().default(true),
  created_at: z.coerce.date(),
  updated_at: z.coerce.date(),
});

export type UserModel = z.infer<typeof userSchema>;

export const userLoginSchema = createUserSchema
  .pick({
    email: true,
    password: true,
  })
  .extend({
    email: z
      .string({ required_error: "Email is required" })
      .email({ message: "Invalid Credentials" }),
    password: z
      .string({ required_error: "Password is required" })
      .min(8, { message: "Invalid Credentials" }),
  });

export type UserLoginModel = z.infer<typeof userLoginSchema>;

export const updateUserSchema = createUserSchema.partial();

export type UpdateUserModel = z.infer<typeof updateUserSchema>;

export type UserResponseModel = {
  title: string;
  status: number;
  type: string;
  success: boolean;
  message: string;
  data: {
    user: UserModel | UserModel[];
    token?: string;
    accessToken?: string;
    refreshToken?: string;
  };
};
